import React, { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { Button, Grid } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import LogoBGCompleto from "../../Resources/icons/etermax_brand-gamification_white.svg";
import WPCard from "./WPCard";
import { Languages, Langs } from "../../Utilities/utils";
import "./WhitePapersLanding.css";

const sectors = [
  { value: "agency", label: "form-industry-agency" },
  { value: "announcer", label: "form-industry-marketer" },
  { value: "gaming", label: "form-industry-gaming" },
  { value: "media", label: "form-industry-media" },
  { value: "pressMedia", label: "form-industry-press" },
  { value: "technology", label: "form-industry-tech" },
  { value: "others", label: "form-industry-other" },
];

const cards = [
  { title: "wp5", description: <FormattedMessage id="wp5" /> },
  { title: "wp4", description: <FormattedMessage id="wp4" /> },
  { title: "wp3", description: <FormattedMessage id="wp3" /> },
  { title: "wp2", description: <FormattedMessage id="wp2" /> },
  { title: "wp1", description: <FormattedMessage id="wp1" /> },
];

const WhitePapersLanding = (props) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    email: "",
    sector: "",
    country: "",
    company: "",
    role: "",
  });

  const lang = props.intl.locale;

  const selectedLang = (lng) => (lang === lng ? "selected" : "");

  const changeLang = (lng) => {
    window.location.search = `?lang=${lng}`;
  };

  const scrollToSection = () => {
    document.getElementById("whitepapers").scrollIntoView({ behavior: "smooth" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const isFormComplete = Object.values(formData).every((field) => field !== "");

  const handleAppendSpreadsheet = (
      name,
      lastName,
      email,
      sector,
      country,
      company,
      role,
  ) => {
    if (
        name.trim() === "" ||
        lastName.trim() === "" ||
        email.trim() === "" ||
        sector.trim() === "" ||
        country.trim() === "" ||
        company === "" ||
        role === ""
    ) {
      return;
    }

    const appendSpreadsheet = async (row) => {
      try {
        await fetch(
            `https://newsletter.itools.etermax.com/api/register/big-events`,
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(row),
            }
        )
            .then((data) => data.json())
            .then((data) => {
              console.log(data);
            })
            .catch((e) => console.log(e));
      } catch (e) {
        console.error("Error: ", e);
      }
    };

    const date = new Date();
    const newRow = {
      Nombre: name,
      Apellido: lastName,
      Email: email,
      País: country,
      Sector: sector,
      Compañía: company,
      Cargo: role,
      Fecha: date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear(),
    };

    appendSpreadsheet(newRow).then(() => {
      setFormSubmitted(true);
    });
  };


  const onSubmit = () => {
    if (isFormComplete) {
      handleAppendSpreadsheet(
          formData.name,
          formData.lastname,
          formData.email,
          formData.sector,
          formData.country,
          formData.company,
          formData.role,
      );
    }
  };

  return (
      <>
        <section className="heroBackground">
          <header className="headerWrapper">
            <img src={LogoBGCompleto} alt="" onClick={() => (window.location.href = `./`)} />
            <div className="linksHeader">
              <div className="languagesHeader">
                {Object.entries(Languages).map(([lng, { txt }]) => (
                    <span key={`lng_${lng}`} className={`language ${selectedLang(lng)}`} onClick={() => changeLang(lng)}>
                  <span>{txt}</span>
                </span>
                ))}
              </div>
              <div className="languagesHeaderMobile">
                {Object.entries(Langs).map(([lng, { txt }]) => (
                    <span key={`lng_${lng}`} className={`language ${selectedLang(lng)}`} onClick={() => changeLang(lng)}>
                  <span>{txt}</span>
                </span>
                ))}
              </div>
            </div>
          </header>

          <Grid container>
            <Grid item md={6}>
              <div className="heroDescription">
                <h1>White Papers</h1>
                <h4>
                  <FormattedMessage id="wp_hero_description" />
                  <br />
                  <FormattedMessage id="wp_hero_description1" />
                </h4>
              </div>
            </Grid>
            <Grid item md={4} className="formContainer">
              <h2>
                <FormattedMessage id="form-title1" />
                <br />
                <FormattedMessage id="form-title2" />
              </h2>
              <form className="inputsForm">
                <input
                    type="text"
                    name="name"
                    placeholder={props.intl.formatMessage({id: "form-name"})}
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="text"
                    name="lastname"
                    placeholder={props.intl.formatMessage({id: "form-last name"})}
                    value={formData.lastname}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder={props.intl.formatMessage({id: "form-email"})}
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                />
                <select
                    name="sector"
                    value={formData.sector}
                    onChange={handleInputChange}
                    required
                    className="selectSector"
                >
                  <option value="">
                    {props.intl.formatMessage({id: "form-industry"})}
                  </option>
                  {sectors.map((sector) => (
                      <option key={sector.value} value={sector.value}>
                        {props.intl.formatMessage({id: sector.label})}
                      </option>
                  ))}
                </select>
                <input
                    type="text"
                    name="country"
                    placeholder={props.intl.formatMessage({id: "form-country"})}
                    value={formData.country}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="text"
                    name="company"
                    placeholder={props.intl.formatMessage({id: "form-company"})}
                    value={formData.company}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="text"
                    name="role"
                    placeholder={props.intl.formatMessage({id: "form-position"})}
                    value={formData.role}
                    onChange={handleInputChange}
                    required
                />
              </form>
              <section className="conditions">
                <p className="conditionsParagraph">
                  <FormattedMessage id="form-disclaimer"/>
                </p>
              </section>
              <Button onClick={onSubmit} disabled={!isFormComplete || formSubmitted} className="submitButton">
                {formSubmitted ? <FormattedMessage id="form-sent"/>
                    : <FormattedMessage id="form-download"/>}
              </Button>

            </Grid>
          </Grid>

          <div className="scrollDown" onClick={scrollToSection}>
            <ArrowDownwardIcon />
            <p>
              <FormattedMessage id="scroll_down" />
            </p>
          </div>
        </section>

        <section className="whitepapersWrapper" id="whitepapers">
          {cards.map((card) => (
              <WPCard
                  key={card.title}
                  title={card.title}
                  description={card.description}
                  backgroundUrl={`https://whitepaper-bg.s3.amazonaws.com/background-${card.title}.png`}
                  label={<FormattedMessage id="download" />}
                  pdfUrl={`https://whitepaper-bg.s3.amazonaws.com/${card.title}-${lang}.pdf`}
                  customClass="greenButton"
                  disabled={!formSubmitted}
                  target={"_blank"}
              />
          ))}
        </section>

        <footer className="footerWhitepaper">
          <h5>Etermax. Todos los derechos reservados.</h5>
          <div className="rightsWPFooter">
            <a href={`https://www.etermax.com/terms/?lang=${lang}#introduction-bg`}>
              <FormattedMessage id="footer_terms_and_conditions" />
            </a>
            <a href={`https://www.etermax.com/privacy/?lang=${lang}#introduction-bg`}>
              <FormattedMessage id="footer_privacy_policy" />
            </a>
          </div>
        </footer>
      </>
  );
};

export default withRouter(injectIntl(WhitePapersLanding));
